import { render, staticRenderFns } from "./History.vue?vue&type=template&id=ab15a4b0&scoped=true&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"
import style0 from "./History.vue?vue&type=style&index=0&id=ab15a4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab15a4b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab15a4b0')) {
      api.createRecord('ab15a4b0', component.options)
    } else {
      api.reload('ab15a4b0', component.options)
    }
    module.hot.accept("./History.vue?vue&type=template&id=ab15a4b0&scoped=true&", function () {
      api.rerender('ab15a4b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/FinalDocuments/History.vue"
export default component.exports